exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-background thead{background-color:#a9e4ce;border-color:#d3d3d3;border-width:2px;height:40px;position:sticky;top:0;font-size:11px}.my-custom-scrollbar{position:relative;height:550px;overflow:auto}.table-wrapper-scroll-y{display:block}.md-body-1,.pendencyBody{font-size:11px;font-weight:400}.table-background>tbody{font-size:11px}.table-background>thead{color:#000}.status-alerts{font-size:18px}.alert-danger-text{color:#d9534f}.alert-info-text{color:#2a6fde}.blink{animation:blinker 1s linear infinite;font-weight:800;color:red}@keyframes blinker{50%{opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5cfae027","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/Pendency/jobCommonPendency.vue
// module id = 1633
// module chunks = 0